/*
 * Palo Alto Theme - Custom JavaScript
 *
 * Consolidated custom interactions and globally delegated handlers.
 */

(function () {
  'use strict';

  /* =========================================================================
   * Sibling Colour Swatch Interactions & Hover Previews
   * ========================================================================= */
  function initSiblingSwatches() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('.product-grid-item .relateditems a');
      if (!a) return;
      e.preventDefault();

      var link = a.getAttribute('href');
      var image = a.getAttribute('data-image');
      var title = a.getAttribute('data-title');
      var card = a.closest('.product-grid-item');
      if (!card) return;

      var container = card.querySelector('.product-grid-item__image');
      if (container) {
        var containerLinks = container.querySelectorAll('a.product__media__holder, a.btn--quick.rounded');
        containerLinks.forEach(function (el) {
          el.setAttribute('href', link);
        });
        var containerImage = container.querySelector('.product__media img');
        if (containerImage && image) {
          containerImage.setAttribute('srcset', image);
        }
      }

      var titleLink = card.querySelector('.product-grid-item__info-content a.product-grid-item__title');
      if (titleLink) {
        if (link) titleLink.setAttribute('href', link);
        if (title) titleLink.textContent = title;
      }
    });

    var preloadedCards = new WeakSet();
    function preloadCardSwatches(card) {
      if (preloadedCards.has(card)) return;
      preloadedCards.add(card);

      card.querySelectorAll('.relateditems a[data-image]').forEach(function (a) {
        var src = a.getAttribute('data-image');
        if (!src) return;
        var im = new Image();
        if ('fetchPriority' in im) im.fetchPriority = 'low';
        im.decoding = 'async';
        im.src = src;
      });
    }

    function siblingPreviewFor(link) {
      var card = link.closest('[data-product-block]');
      if (!card) return null;
      var host = card.querySelector('[data-product-media-featured]') || card.querySelector('.product__media__image');
      if (!host) return null;

      var img = host.querySelector('.sibling-hover-preview');
      if (!img) {
        img = document.createElement('img');
        img.className = 'sibling-hover-preview';
        img.alt = '';
        img.setAttribute('aria-hidden', 'true');
        host.appendChild(img);
      }
      return img;
    }

    document.addEventListener('mouseover', function (e) {
      if (!e.target.closest) return;
      var card = e.target.closest('[data-product-block]');
      if (card) preloadCardSwatches(card);

      var link = e.target.closest('.relateditems a[data-image]');
      if (!link) return;
      var src = link.getAttribute('data-image');
      var img = siblingPreviewFor(link);
      if (!img || !src) return;

      if (img.getAttribute('src') === src) {
        img.classList.add('is-visible');
        return;
      }
      img.classList.remove('is-visible');
      img.onload = function () {
        img.classList.add('is-visible');
      };
      img.src = src;
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add('is-visible');
      }
    });

    document.addEventListener('mouseout', function (e) {
      if (!e.target.closest) return;
      var link = e.target.closest('.relateditems a[data-image]');
      if (!link) return;
      if (e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('.relateditems a[data-image]') === link) {
        return;
      }
      var card = link.closest('[data-product-block]');
      var img = card && card.querySelector('.sibling-hover-preview');
      if (img) img.classList.remove('is-visible');
    });
  }

  /* =========================================================================
   * Collection Filter Checkbox & Tile Toggle Synchronization
   * ========================================================================= */
  function initCollectionFilterToggles() {
    function normalizeStr(str) {
      if (!str) return '';
      var s = str.toString().toLowerCase().trim();
      if (s.normalize) {
        s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      }
      return s.replace(/[^a-z0-9]/g, ' ').replace(/\s+/g, ' ').trim();
    }

    function getStyleKey(str) {
      if (!str) return '';
      var norm = normalizeStr(str);
      var words = norm.split(' ').filter(Boolean);
      return words[0] || '';
    }

    function findMatchingFilterInput(form, paramName, paramValue) {
      if (!form || !paramValue) return null;

      var escapeFn = window.CSS && window.CSS.escape ? window.CSS.escape : function (v) {
        return v.replace(/["\\]/g, '\\$&');
      };

      // 1. Direct match with paramName + paramValue
      if (paramName) {
        try {
          var direct = form.querySelector(
            'input[name="' + escapeFn(paramName) + '"][value="' + escapeFn(paramValue) + '"]'
          );
          if (direct) return direct;
        } catch (e) {}
      }

      // 2. Direct match with value only
      try {
        var directVal = form.querySelector('input[value="' + escapeFn(paramValue) + '"]');
        if (directVal) return directVal;
      } catch (e) {}

      var targetKey = getStyleKey(paramValue);
      var targetNorm = normalizeStr(paramValue);
      var allInputs = form.querySelectorAll('input[type="checkbox"]');

      // 3. Search through checkboxes by normalized value, label text, or style key
      for (var i = 0; i < allInputs.length; i++) {
        var input = allInputs[i];
        var inVal = input.value || input.getAttribute('value') || '';
        var inNorm = normalizeStr(inVal);

        if (inNorm && inNorm === targetNorm) {
          return input;
        }

        // Check associated label
        var label = null;
        if (input.id) {
          label = form.querySelector('label[for="' + escapeFn(input.id) + '"]');
        }
        if (!label) {
          label = input.closest('label') || (input.parentElement ? input.parentElement.querySelector('label') : null);
        }
        var labelText = label ? label.textContent : '';
        var labelNorm = normalizeStr(labelText);

        if (labelNorm && labelNorm === targetNorm) {
          return input;
        }

        // Match by style key (e.g., "quinn", "ace", "lulu", "anastasia", "lydia", "elodia", etc.)
        if (targetKey && targetKey.length >= 2) {
          var inKey = getStyleKey(inVal);
          var labelKey = getStyleKey(labelText);
          if (inKey === targetKey || labelKey === targetKey) {
            return input;
          }
          if ((inNorm && inNorm.indexOf(targetKey) === 0) || (labelNorm && labelNorm.indexOf(targetKey) === 0)) {
            return input;
          }
        }
      }

      return null;
    }

    function syncFilterCheckmarks() {
      var form = document.querySelector('[data-collection-filters-form]');
      var triggers = document.querySelectorAll('[data-filter-toggle]');

      triggers.forEach(function (trigger) {
        var item = trigger.closest('.list-collections__item');
        if (!item) return;

        var isActive = false;
        var paramName = trigger.getAttribute('data-filter-param');
        var paramValue = trigger.getAttribute('data-filter-value');

        if (form && paramValue) {
          var input = findMatchingFilterInput(form, paramName, paramValue);
          isActive = !!(input && input.checked);
        }

        // Fallback: check URL query parameters if form is not yet ready or input checked state not yet reflected
        if (!isActive && paramValue) {
          try {
            var urlParams = new URLSearchParams(window.location.search);
            var targetKey = getStyleKey(paramValue);
            urlParams.forEach(function (val, key) {
              if (paramName && key === paramName) {
                if (val === paramValue || normalizeStr(val) === normalizeStr(paramValue) || (targetKey && getStyleKey(val) === targetKey)) {
                  isActive = true;
                }
              } else if (key.indexOf('style') !== -1 || key.indexOf('custom') !== -1) {
                if (val === paramValue || (targetKey && getStyleKey(val) === targetKey)) {
                  isActive = true;
                }
              }
            });
          } catch (e) {}
        }

        item.classList.toggle('list-collections__item--filter-selected', isActive);
      });
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-filter-toggle]');
      if (!trigger) return;

      var form = document.querySelector('[data-collection-filters-form]');
      if (!form) return;

      var paramName = trigger.getAttribute('data-filter-param');
      var paramValue = trigger.getAttribute('data-filter-value');
      if (!paramValue) return;

      var input = findMatchingFilterInput(form, paramName, paramValue);
      if (!input) return;

      event.preventDefault();
      input.checked = !input.checked;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      syncFilterCheckmarks();
    });

    document.addEventListener('theme:filters:init', syncFilterCheckmarks);
    document.addEventListener('DOMContentLoaded', syncFilterCheckmarks);
    window.addEventListener('load', syncFilterCheckmarks);
    window.addEventListener('popstate', function () {
      setTimeout(syncFilterCheckmarks, 100);
    });
    if (document.readyState !== 'loading') {
      syncFilterCheckmarks();
    }
  }

  // Initialize features
  initSiblingSwatches();
  initCollectionFilterToggles();
})();
